import React from 'react';
import { Badge, Modal, Table } from 'react-bootstrap';
import QtyDual from '../../utils/inventoryUnit';

const fmtPct = (n) => {
  const v = Number(n ?? 0);
  return `${v >= 0 ? '+' : ''}${v.toFixed(1)}%`;
};

// #013556 (lệnh sếp 24/08/2026): nhãn hiển thị dấu hiệu "kiểm ẩu" — mirror
// ShiftMaterialCheckTab.js (2 dấu hiệu chung) + thêm repeated_edits (riêng cho kiểm kê định kỳ,
// nơi NV có thể sửa lại số nhiều lần trước khi hoàn thành phiên).
const SUSPICIOUS_REASON_LABELS = {
  exact_match_all: 'Số nhập trùng khít tuyệt đối toàn bộ NVL',
  too_fast: 'Nhập quá nhanh so với số dòng NVL',
  repeated_edits: 'Sửa lại số nhiều lần trong thời gian ngắn',
};

export default function StocktakeDetailModal({ show, onHide, session, materialsById }) {
  if (!session) return null;

  const items = session.items || [];

  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>
          Chi tiết kiểm kê — {session.branch?.name}
          {' '}
          <Badge bg={session.status === 'COMPLETED' ? 'success' : 'warning'}>
            {session.status === 'COMPLETED' ? 'Hoàn thành' : 'Đang kiểm'}
          </Badge>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="mb-3 small text-muted">
          <span>NV: <strong>{session.employee?.full_name || '—'}</strong></span>
          {' · '}
          <span>Ngày: {new Date(session.created_at).toLocaleDateString('vi-VN')}</span>
          {session.completed_at && (
            <span> · Hoàn thành: {new Date(session.completed_at).toLocaleTimeString('vi-VN', { hour: '2-digit', minute: '2-digit' })}</span>
          )}
          {' · '}
          <span>Chênh lệch: {session.items_with_variance || 0}/{session.total_items || 0} NVL</span>
        </div>

        {session.is_suspicious && (
          <div className="alert alert-danger py-2 px-3 small mb-3">
            <strong>⚠ Cờ "kiểm ẩu" (chỉ để hậu kiểm, không tự chặn/phạt):</strong>{' '}
            {(session.suspicious_reasons || [])
              .map((r) => SUSPICIOUS_REASON_LABELS[r] || r)
              .join('; ')}
          </div>
        )}

        {items.length === 0 ? (
          <p className="text-muted text-center py-3">Chưa có dữ liệu kiểm kê</p>
        ) : (
          <Table bordered size="sm" responsive>
            <thead>
              <tr>
                <th>NVL</th>
                <th className="text-end">Lý thuyết</th>
                <th className="text-end">Thực tế</th>
                <th className="text-end">Chênh lệch</th>
                <th className="text-end">%</th>
                <th>Ghi chú</th>
              </tr>
            </thead>
            <tbody>
              {items.map((item) => {
                const variance = Number(item.variance ?? 0);
                const isOk = Math.abs(variance) < 0.001;
                const mat = (materialsById && materialsById.get(item.material_id)) ?? item.material;
                return (
                  <tr key={item.id} className={!isOk ? (variance < 0 ? 'table-danger' : 'table-info') : ''}>
                    <td>{item.material?.name || item.material_id}</td>
                    <td className="text-end">
                      <QtyDual quantityInBase={item.theoretical_quantity} material={mat} />
                    </td>
                    <td className="text-end">
                      <QtyDual quantityInBase={item.actual_quantity} material={mat} />
                    </td>
                    <td className={`text-end fw-medium ${isOk ? '' : variance < 0 ? 'text-danger' : 'text-primary'}`}>
                      {variance >= 0 ? '+' : ''}<QtyDual quantityInBase={Math.abs(variance)} material={mat} />
                    </td>
                    <td className="text-end">{fmtPct(item.variance_percentage)}</td>
                    <td className="small text-muted">{item.note || '—'}</td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        )}
      </Modal.Body>
    </Modal>
  );
}
